import React, { useState } from 'react';

//helpers
import { checkValue, onImageLoadWithoutCache } from 'src/components/common/helper';
import  ImageFallback  from 'src/components/common/Image-fallback ';

//types
import { CopyrightCameraProps } from './code-split/copyright-with-gradient-component';

// Css Style Import
import(/* webpackChunkName: "copyright-with-gradient-styles" */ 'src/components/common/modules/copyright-with-gradient/styles/copyright-with-gradient.css');

const copyrightWithGradient: React.FC<CopyrightCameraProps> = ({
  copyrightText = '',
  copyrightCation = '',
  position = 'br',
  iconSize = 'lg',
}) => {
  const [isShow, toggleIsShow] = useState(false);

  if (!checkValue(copyrightText) && !checkValue(copyrightCation)) {
    return null;
  }

  const onMouceOver = (e) => {
    e.stopPropagation();
    e.preventDefault();
    toggleIsShow(true);
  };

  const onMouceLeave = (e) => {
    e.stopPropagation();
    e.preventDefault();
    toggleIsShow(false);
  };
  
  return (
    <>   
        <div className={`cpwg-image-gradient ${isShow ? 'is-active' : ''}`}></div>
        <div className={`cpwg-section ${position} ${isShow ? 'is-active' : ''}`}>
          <div className="cpwg-copyright-text">
            <span>{copyrightText}</span>
            <span>{copyrightCation}</span>
          </div>
          
          <ImageFallback 
            src={onImageLoadWithoutCache("https://mesovideo2.azureedge.net/video/camera.svg")}
            className={`cpwg-camera-icon ${iconSize}`}
            onClick={(e) => onMouceOver(e)}
            onMouseOver={(e) => onMouceOver(e)}
            onMouseLeave={(e) => onMouceLeave(e)}
          />
        </div>{' '}    
    </>
  );
};

export default copyrightWithGradient;
